<form (ngSubmit)="onSubmit()" #filtersForm="ngForm" class="filter-dialog__form">
  <mat-dialog-content>
    <mat-tab-group
      [mat-stretch-tabs]="false"
      [selectedIndex]="savedTabIndex"
      (selectedIndexChange)="onTabGroupSelectedIndexChanged($event)">
      <mat-tab label="Time">
        <app-time-tab></app-time-tab>
      </mat-tab>
      <mat-tab label="Areas">
        <app-areas-tab></app-areas-tab>
      </mat-tab>
      <mat-tab label="Offense Desc">
        <app-offence-desc-tab></app-offence-desc-tab>
      </mat-tab>
      <mat-tab label="Vehicles">
        <app-vehicles-tab></app-vehicles-tab>
      </mat-tab>
      <mat-tab label="Demographics">
        <app-demographics-tab></app-demographics-tab>
      </mat-tab>
      <mat-tab label="Stop Details">
        <app-stop-details-tab />
      </mat-tab>
      <mat-tab *ngIf="isPersonnel" label="Personnel">
        <app-personnel-tab></app-personnel-tab>
      </mat-tab>
      <!-- TODO: delete app-personal-tab? -->
      <mat-tab *ngIf="isPersonalInfoEnabled" label="Personal">
        <app-personal-tab></app-personal-tab>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="footer">
    <hr />
    <button mat-button type="button" class="custom-button footer__reset-btn" (click)="reset()">Clear All</button>
    <button mat-stroked-button type="button" class="custom-button footer__close-btn" (click)="close()">Cancel</button>
    <button mat-flat-button type="submit" color="primary" [disabled]="filtersForm.invalid || !filtersForm.dirty">
      Apply
    </button>
  </mat-dialog-actions>
</form>
